import { create } from "zustand";

interface NavbarState {
	isMenuOpen: boolean;
	isScrolled: boolean;

	setMenuOpen: (open: boolean) => void;
	toggleMenu: () => void;
	closeMenu: () => void;
	setScrolled: (scrolled: boolean) => void;
}

export const useNavbarStore = create<NavbarState>()((set) => ({
	isMenuOpen: false,
	isScrolled: false,

	setMenuOpen: (isMenuOpen) => set({ isMenuOpen }),
	toggleMenu: () => set((state) => ({ isMenuOpen: !state.isMenuOpen })),
	closeMenu: () => set({ isMenuOpen: false }),
	setScrolled: (isScrolled) => set({ isScrolled }),
}));
